import React, { useEffect, useState } from "react";
import Route from "./pages/Route";

import "./assets/css/style.css";
//import "./assets/css/skin/skin-1.css";
import "swiper/css";
import { configureAxios } from "./apis/axios-config";
import { AppContext } from "./context/AppContext";

function App() {
  const [user, setUser] = useState(null);

  configureAxios(user?.access);

  useEffect(() => {
    checkAuth();
  }, [user]);

  const checkAuth = () => {
    if (!user) {
      let userData = localStorage.getItem("user");

      if (!userData) {
        setUser({});
        return false;
      } else {
        setUser(JSON.parse(userData));
        return true;
      }
    } else {
      return true;
    }
  };

  const handleLogOut = async () => {
    setUser({});
    localStorage.removeItem("user");

    // try {
    //   await logout();

    //   setUser({});
    //   localStorage.removeItem('user');
    // } catch (error) {
    //   setUser({});
    //   localStorage.removeItem('user');
    // }
  };

  if (!user) return <h1>Loading ...</h1>;

  return (
    <AppContext.Provider
      value={{
        user,
        setUser,
        handleLogOut,
      }}
    >
      <Route />
    </AppContext.Provider>
  );
}

export default App;
